import * as d3 from 'd3-selection'

export default function (selection, dimensions) {
  selection.each(function () {
    var behind = d3.select(this)
                 .selectAll('rect.gantt-item-complete-behind-indicator')
                 .data(d => {
                   if (!d.scheduleStatus.startsWith('behind') || d.state !== 'gantt-item-complete') {
                     // Don't draw since it's not behind
                     return []
                   }
                   var text = d3.select(this).select('text')
                   if (!text.node()) {
                     // If there wasn't space for the text label, there's not enough space for this behind indicator either
                     return []
                   }

                   var textLength = text.node().getComputedTextLength()

                   if ((d._gantt.foregroundWidth - textLength - dimensions.behind.outer.width) < dimensions.behind.outer.width) {
                     // not enough space to draw the shape
                     return []
                   }

                   return [{
                     x: d._gantt.foregroundWidth + d._gantt.x - dimensions.behind.outer.width - textLength - dimensions.behind.padding.right,
                     y: dimensions.margin.top + dimensions.behind.padding.top,
                     width: dimensions.behind.outer.width,
                     height: dimensions.behind.outer.height,
                     rx: 2,
                     scheduleStatus: d.scheduleStatus,
                     clazz: 'outer'
                   }, {
                     x: d._gantt.foregroundWidth + d._gantt.x - dimensions.behind.inner.width - (dimensions.behind.outer.width - dimensions.behind.inner.width) / 2 - textLength - dimensions.behind.padding.right,
                     y: dimensions.margin.top + dimensions.behind.padding.top + (dimensions.behind.outer.height - dimensions.behind.inner.height) / 2,
                     width: dimensions.behind.inner.width,
                     height: dimensions.behind.inner.height,
                     scheduleStatus: d.scheduleStatus,
                     clazz: 'inner'
                   }]
                 })

    behind.exit().remove()

    behind.enter()
        .append('rect')
        .attr('class', d => `gantt-item-complete-behind-indicator gantt-item-complete-behind-indicator-${d.clazz} gantt-item-complete-${d.scheduleStatus}-indicator`)
        .merge(behind)
        .attr('x', d => d.x)
        .attr('y', d => d.y)
        .attr('rx', d => d.rx)
        .attr('width', d => d.width)
        .attr('height', d => d.height)
  })
}
